import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`client.capture({
    distinctId: 'distinct_id',
    event: 'Order created',
    properties: {
        orderId: '#0054'
        subtotal: 3599,
        customerName: 'Max Hedgehog',
    },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    'distinct_id',
    'Order created',
    {
        'orderId': '#0054',
        'subtotal': 3599,
        'customerName': 'Max Hedgehog',
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
  'distinctId' => 'distinct_id',
  'event' => 'Order created',
  'properties' => array(
    'orderId' => '#0054'
    'subtotal' => 3599,
    'customerName' => 'Max Hedgehog'
  )
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog.capture({
    distinct_id: 'distinct_id',
    event: 'Order created',
    properties: {
        orderId: '#0054',
        subtotal: 3599,
        customerName: 'Max Hedgehog'
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
  DistinctId: "distinct_id",
  Event:      "Order created",
  Properties: posthog.NewProperties().
    Set("orderId", "#0054").
    Set("subtotal", 3599).
    Set("customerName", "Max Hedgehog"),
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`posthog.capture(
  "distinct id",
  "movie played",
  new HashMap<String, Object>() {
    {
      put("orderId", "#0054");
      put("subtotal", 3599);
      put("customerName", "Max Hedgehog");
    }
  }
);
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      